
import './App.css';
import AttendanceForm from './components/AttendanceForm';

function App() {
  return (
    <div className="App">
      <h1>出勤表单</h1>
      <AttendanceForm />
    </div>
  );
}

export default App;
